import React, { Component } from 'react';
import classNames from 'classnames';
const TimelineMax = window.TimelineMax

class Service extends Component {
	constructor(props) {
		super(props);

	}

  componentWillEnter(callback) {
    // console.log('pagecontainer will enter', this.props.tester);
    this.animateIn(callback);
  }

  componentDidEnter(){
    // console.log('pagecontainer did enter', this.props.tester);
    this.props.transitionEnd();
  }


  componentWillLeave(callback) {
    // console.log('pagecontainer will leave', this.props.tester);
    this.animateOut(callback);
    // callback();
  }

  componentDidLeave(){
    // console.log('pagecontainer did leave', this.props.tester);
  }

  renderDescList(service) {
    return service.bullets.map((li, i) => {
      return <li key={i}>{li}</li>
    });
  }

  render() {
    let service = this.props.service
    let bulletList = this.renderDescList(service)
    return (
      <div className="service-item" ref={(el) => this.el = el}>
        <img src={service.img} />
        <h1>{service.title}</h1>
        <p>{service.description}</p>
        <ul>
          {bulletList}
        </ul>
        
      </div>
    );
  }

  animateIn(callback){
    var tween = new TimelineMax({onComplete: callback})
    let el = this.el
    // let staggers = el.querySelectorAll('.stagger-in');

    tween
    .set(el, {opacity: 0})
    .to(el, 0.4, {
      opacity: 1,
      // ease: Sine.easeIn
    }, 0.4)
    // .staggerTo(staggers, 0.6, {opacity: 1}, 0.64, '-=1')
  }

  animateOut(callback){
    var tween = new TimelineMax({onComplete: callback})

    tween
    .to(this.el, 0.4, {
      opacity: 0,
      // ease: Sine.easeIn
    })
  }
}

export default Service;



// WEBPACK FOOTER //
// ./src/scripts/components/service.js